import { AudioManager } from "../../../../audio/AudioManager";
import { Sprite } from "@pixi/sprite";
import { ScaleUpButton } from "./ScaleUpButton";
import { ButtonOptions } from "./ButtonOptions";

export class ScaleUpIconButton extends ScaleUpButton {
    protected readonly icon: Sprite;
    public constructor(
        options: ButtonOptions,
        audioManager: AudioManager
    ) {
        super(options, audioManager);
        if(this.options.iconOptions != null) {
            this.icon = this.defaultView.addChild(new Sprite(this.options.iconOptions.icon));
            if(this.options.iconOptions.positionOption != null) {
                this.icon.position.set(this.options.iconOptions.positionOption.x, this.options.iconOptions.positionOption.y);
            }
        }
    }
}
